import { useAuth } from "@workos-inc/authkit-react";
import {
  isNarrativeEasterEggEnabled,
  isNarrativeEasterEggFinderEnabled,
} from "./featureFlag";

export interface NarrativeEasterEggState {
  enabled: boolean;
  /**
   * `narrative-easter-egg-finder` AND `narrative-easter-egg` — already
   * conjoined here so callers can't surface the finder for a station that has
   * the parent feature off.
   */
  finderEnabled: boolean;
  loaded: boolean;
}

export function useNarrativeEasterEggEnabled(): NarrativeEasterEggState {
  const { featureFlags, isLoading } = useAuth();
  const enabled = isNarrativeEasterEggEnabled(featureFlags);
  return {
    enabled,
    finderEnabled: enabled && isNarrativeEasterEggFinderEnabled(featureFlags),
    loaded: !isLoading,
  };
}
